


















































import { Component } from 'vue-property-decorator';
import { OrganisationModule } from '@/store/Customers/OrganisationModule';
import Alert from '@/components/Shared/Alert.vue';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import OrganisationDetails from '@/components/Customers/Organisations/OrganisationDetails.vue';
import RelatedCustomers from '@/components/Customers/Customers/RelatedCustomers.vue';
import RelatedRecords from '@/components/Customers/Customers/RelatedRecords.vue';
import Addresses from '@/components/Customers/Customers/Addresses.vue';
import PageNames from '@/router/PageNames';

@Component({ name: 'Organisation', components: { Alert, OrganisationDetails, RelatedCustomers, RelatedRecords, Addresses }, metaInfo: { title: 'Organisations' } })
export default class extends SaascadaVue {

    tabIndex = 0;

    async created() {
        // Check for tab index number in URL parameters
        const tab = this.$route.query.tab;
        if (tab) {
            this.tabIndex = +tab;
        }
        else {
            this.$router.push({ name: this.$route.name, params: { id: this.$route.params.id }, query: { tab: `0` } });
        }
    }

    async beforeMount() {
      await OrganisationModule.getOrganisation(this.$route.params.id);
    }

    get organisation() {
      return OrganisationModule.organisation;
    }

    get loading() {
      return OrganisationModule.loading;
    }

    async changeTab() {
        // Update route with tab number
        this.$router.push({ name: PageNames.Organisation, params: { id: this.$route.params.id }, query: { tab: `${this.tabIndex}` } });
    }

}
